/**
 * @file Clés de stockage local liées à la session utilisateur.
 * @module packages.common.utils.sessionStorageKeys
 *
 * Ces clés sont écrites par les contextes d'authentification et d'accès
 * opérateur, lues par les guards, et effacées à la fin de session. Écrites en
 * dur de chaque côté, un renommage d'un seul côté laisserait l'autre lire dans
 * le vide sans la moindre erreur visible : la session ne se nettoierait plus,
 * en silence. Elles vivent donc ici, et nulle part ailleurs.
 */

/** État d'authentification persisté : qui est connecté. */
export const AUTH_STATE_KEY = 'authState';

/** État du mode accès client du panel opérateur. */
export const ADMIN_ACCESS_STATE_KEY = 'adminAccessState';

/**
 * Drapeau posé à la fin d'une session, lu par `AuthGuard` : il lui dit de ne pas
 * mémoriser la page courante comme destination de retour, puisque la session
 * vient de finir et non d'être interrompue.
 */
export const RECENTLY_LOGGED_OUT_KEY = 'recentlyLoggedOut';

/** Chemin demandé avant la connexion, restitué juste après. */
export const PRE_AUTH_PATH_KEY = 'preAuthPath';

/**
 * Clés effacées à la fin d'une session.
 *
 * `preAuthPath` en fait partie : laissé derrière, il renverrait la personne
 * suivante à se connecter sur la page de la précédente.
 */
export const SESSION_STORAGE_KEYS = [AUTH_STATE_KEY, ADMIN_ACCESS_STATE_KEY, PRE_AUTH_PATH_KEY];
